import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Reference } from '../../../models';
import { ReferenceModalComponent } from '../reference-modal/reference-modal.component';


/**
 * Component class for text content references
 */
@Component({
    selector: 'rms-text-content-references',
    templateUrl: './text-content-references.component.html',
    styleUrls: ['./text-content-references.component.scss'],
    standalone: false
})
export class TextContentReferencesComponent implements OnInit {

  @Input() references: Array<Reference>;
  @Input() entity: string;
  @Input() isReadOnly: boolean;
  @ViewChild(ReferenceModalComponent, { static: true }) referenceModal: ReferenceModalComponent;

  constructor() { }

  ngOnInit() { }

  /**
   * Opens the text content reference modal
   * @param references
   */
  public openReferenceModal (references: Array<Reference>): void {
    this.referenceModal.openModal(references);
  }
}
